import { Helmet } from 'react-helmet-async';
import Body from './body';
import HistoryProvider from './provider';

function CreateRaffleDraw() {
  return (
    <HistoryProvider>
    <>
      <Helmet>
        <title> Raffle Draw </title>
      </Helmet>
      <Body />
    </>
    </HistoryProvider>
  );
}

export default CreateRaffleDraw;
